// FXM Messenger — standalone entry point.
//
// Renders the chat app directly on its own JWT auth + FastAPI backend (server/).
// The whole UI lives under ./fresh/chat and talks only to our own API
// (fresh/chat/api.ts). See DECOUPLING.md for the extraction record.
import React from 'react';
import { createRoot } from 'react-dom/client';

// Font + styles loaded up front so the login/landing screens are styled before the
// authenticated app mounts (ChatApp also imports these; the bundler dedupes).
import '@fontsource/inter/variable.css';
import './fresh/fresh.css';
import './fresh/chat/chat.css';

import { ChatRoot } from './fresh/chat/ChatRoot';
import { registerServiceWorker } from './fresh/chat/push';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(<ChatRoot />);

// Register the Web Push service worker (no-op where unsupported). Subscribing to push
// stays user-initiated from Settings → Notifications; this only installs the worker.
registerServiceWorker();
